import React from "react";

import { useSelector, useDispatch } from "react-redux";

import { hide } from "../../store/ducks/alert";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  createMuiTheme,
  ThemeProvider,
  makeStyles,
} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import useMediaQuery from "@material-ui/core/useMediaQuery";

function AlertUI(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const Alert = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const alert = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hide());
  };

  const classes = useStyles();

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        MuiPopover: {
          style: {
            backgroundColor: "#424242",
          },
        },
        palette: {
          type: "dark",
        },
      }),
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={classes.root}>
        <Snackbar open={alert.showAlert} onClose={handleClose}>
          <AlertUI onClose={handleClose} severity={alert.alertType}>
            {alert.alertMessage}
          </AlertUI>
        </Snackbar>
      </div>
    </ThemeProvider>
  );
};

export default Alert;
